import script from "./chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./chart.vue?vue&type=script&lang=ts&setup=true"

import "./chart.vue?vue&type=style&index=0&id=5476705b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5476705b"]])

export default __exports__